import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  notification: {
    id: 'phc-web-toolkit.shareLinkButton.notification',
    defaultMessage: 'Link copied to clipboard!',
  },
  tooltip: {
    id: 'phc-web-toolkit.shareLinkButton.tooltip',
    defaultMessage: 'Create a shareable link to this page',
  },
  error: {
    id: 'phc-web-toolkit.shareLinkButton.error',
    defaultMessage: 'Failed to copy link.',
  },
  modalTitle: {
    id: 'phc-web-toolkit.shareLinkButton.modalTitle',
    defaultMessage: 'Create a Share Link',
  },
  modalBody: {
    id: 'phc-web-toolkit.shareLinkButton.modalBody',
    defaultMessage:
      'Since you are logged in with SSO, you can create the link with two options.',
  },
  modalSelectLabel: {
    id: 'phc-web-toolkit.shareLinkButton.modalSelectLabel',
    defaultMessage: 'Choose how to share:',
  },
  modalSelectIncludeSSO: {
    id: 'phc-web-toolkit.shareLinkButton.modalSelectIncludeSSO',
    defaultMessage: 'Require SSO',
  },
  modalSelectIncludeSSOHelp: {
    id: 'phc-web-toolkit.shareLinkButton.modalSelectIncludeSSOHelp',
    defaultMessage:
      'You can share this link with other users that use the same SSO as you',
  },
  modalSelectMakeOpenLink: {
    id: 'phc-web-toolkit.shareLinkButton.modalSelectMakeOpenLink',
    defaultMessage: 'Do not require SSO',
  },
  modalSelectMakeOpenLinkHelp: {
    id: 'phc-web-toolkit.shareLinkButton.modalSelectMakeOpenLinkHelp',
    defaultMessage:
      'You can share this link with other users that do not use the same SSO as you',
  },
  modalCancel: {
    id: 'phc-web-toolkit.shareLinkButton.modalCancel',
    defaultMessage: 'Cancel',
  },
  modalCopy: {
    id: 'phc-web-toolkit.shareLinkButton.modalCopy',
    defaultMessage: 'Create Link',
  },
});
